import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInventoryDashboardStats, InventoryDashboardState } from "../../../types/dashboard/inventoryDashboardInterfaces";


const initialState: InventoryDashboardState = {
  stats: {
    totalProducts: 0,
    productsByCategory: {},
    lowStockProducts: 0,
    activeProducts: 0,
    inactiveProducts: 0,
    movementsInOut: {},
  },
};

export const inventoryDashboardSlice = createSlice({
  name: "inventoryDashboard",
  initialState,
  reducers: {
    /**
     * ✅ Carga las estadísticas correctamente.
     */
    setStats: (state, action: PayloadAction<IInventoryDashboardStats>) => {
      state.stats = action.payload;
    },

    /**
     * 🔄 Permite limpiar el estado si se requiere.
     */
    clearStats: (state) => {
      state.stats = {
        totalProducts: 0,
        productsByCategory: {},
        lowStockProducts: 0,
        activeProducts: 0,
        inactiveProducts: 0,
        movementsInOut: {},
      };
    },
  },
});

export const { setStats, clearStats } = inventoryDashboardSlice.actions;
export default inventoryDashboardSlice.reducer;
